/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getAnnunciatorData (plantId) {
    return Api().get(`/api/v2/annunciator/live-data/${plantId}`)
  },
  getBlockList(plantId) {
    return Api().get(`/api/v1.0/block_list/${plantId}/annunciator`)
  },
  getDeviceList(payload) {
    return Api().post(`/api/v2/annunciator/annunciator-list`,payload)
  }
}